import {
    Background,
    BackgroundColor,
    Container,
    Spacer,
    SpacerVariant,
    backgroundGreyScaleColorsOptions,
} from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import React from "react"

interface SmallprintItemProps {
    background: { color: BackgroundColor } | BackgroundColor
    lessMargin?: boolean
}

const Smallprint: types.Brick<SmallprintItemProps> = ({ background, lessMargin }) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Spacer variant={!!lessMargin ? SpacerVariant.XXS : SpacerVariant.Small} />
            <Container>
                <Repeater propName="repeater" />
            </Container>
            <Spacer variant={!!lessMargin ? SpacerVariant.None : SpacerVariant.Small} />
        </Background>
    )
}

Smallprint.schema = {
    name: "Smallprint",
    label: "Smallprint",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Smallprint.png`,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "SmallprintItem",
                    label: "Smallprint Item",
                    min: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundGreyScaleColorsOptions,
                display: types.OptionsDisplay.Color,
            },
        },
    ],
    getDefaultProps: (): SmallprintItemProps => ({
        background: { color: BackgroundColor.Grey },
    }),
}

export default Smallprint
